import React from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { withUserContext } from "../../../contexts/UserContext";
import TableComponent from "../../../components/SharedComponents/Table";
import { unitConfig } from "./Config";
import "./Unit.scss";
import * as Constants from "../../../constants/constants";
import PostWatchService from "../../../../src/services/service";
import CircularProgress from "@material-ui/core/CircularProgress";
import MessageModal from "../../../../src/components/SharedComponents/MessageModal";
import Message from "../../../../src/Common/Messages.json";
import NotificationComponent from "../../../../src/Common/NotificationComponent/NotificationComponent"

class Unit extends React.Component {
  constructor(props) {
    super(props);
    this.deleteItem = null;
    this.state = {
      postInitiated: false,
      renderList: [],
      isLoading: false,
      config: JSON.parse(JSON.stringify({ ...unitConfig })),
      isMessageModalOpen: false,
      unitSuccess: false,
      deleteSuccess: false
    };
  }
  handleOnChange = (field, value) => {
    this.setState((prevState) => ({
      userPostJson: {
        ...prevState.userPostJson,
        [field]: value,
      },
    }));
  };

  componentDidMount() {
    this.getUnit();
  }
  handleInlineEdits = (id, dataItem) => {
    let tempTable = this.state.renderList;
    // Setunit and Acc are search select which require value and text to render in the table, so here we are building that object
    this.setState({
      renderList: tempTable.map(
        (item) => {
          if (item.lookup_data_id === id) {
            item["editing"] = true;
          }
          return item;
        }
      ),
    });

  };

  saveInlineEdits = (data, index) => {
    this.postData(data[index], "save");
  };

  postData = (data, operation) => {
    console.log("postData data", data);
    data.is_active = data?.is_active ? 0 : 1;
    this.setState({ isLoading: true });
    PostWatchService.postDataParams(
      Constants.postWatchServiceBaseUrl +
      `/postlookupdata?userId=` +
      this.props?.userContext?.user_profile?.user_id,
      data,
      this.props.userContext?.active_tenant?.tenant_id,
      1
    ).then(
      (response) => {
        if (response.data[0]?.Level === "Error") {
          this.setState({
            isErrorMessageModalOpen: true,
            isMessageModalOpen: false,
            isLoading: false,
          });
        } else {
          this.setState({
            isMessageModalOpen: false,
            isLoading: false,
            postInitiated: false,
            unitSuccess: operation === "save" ? true : false,
            deleteSuccess: operation === "delete" ? true : false
          }, () => { this.getUnit(); });
          this.deleteItem = null;
        }
      },
      (err) => {
        this.setState({ isLoading: false });
        console.log("Post agency details error: " + err);
      }
    );
  };
  getUnit = () => {
    this.setState({
      isLoading: true
    });
    PostWatchService.getData(
      Constants.postWatchServiceBaseUrl +
      '/getlookupdata?objectType=unit',
      this.props?.userContext?.active_tenant?.tenant_id
    )
      .then((res) => {
        let tableResults = res.data?.results?.map((obj) => {
          obj.is_active = obj?.is_active ? 0 : 1;
          return obj;
        });
        this.setState({
          renderList: tableResults,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ isLoading: false });
      });
  };

  handleAddNewItem = (newDataItem) => {
    this.setState({ postInitiated: true, isLoading: true });
    if (newDataItem) {
      newDataItem.lookup_data_id = null;
      newDataItem.lookup_type = "Unit";
      newDataItem.tenant_id = this.props.userContext?.active_tenant?.tenant_id;
      this.postData(newDataItem, "save");
    } else {
      // This will not clear already entered data
      unitConfig.isClearFields = false;
    }
  };

  handleDelCallBack = (id, dataItem) => {
    this.deleteItem = dataItem;
    this.setState({ isMessageModalOpen: true });
  };

  onModalConfirm = () => {
    let item = { ...this.deleteItem };
    item.is_deleted = 1;
    this.postData(item, "delete");
  };

  handleResetNotify = () => {
    this.setState({ unitSuccess: false });
  }

  render() {
    return (
      <div>
        <MDBContainer className="unitAdminContainer">
          <NotificationComponent
            open={
              this.state.unitSuccess || this.state.deleteSuccess
            }
            message={this.state.unitSuccess ? "Saved Successfully" : "Deleted Successfully"}
            severity={"success"}
            handleResetNotify={this.handleResetNotify.bind(this)}
          />

          <MDBRow className="table-striped">
            {this.state?.isLoading ? (
              <div className="ContentLoader">
                <CircularProgress />
              </div>
            ) : (
              <>
                <TableComponent
                  list={this.state.renderList || []}
                  className={"clearencRecord"}
                  config={this.state?.config}
                  isLoading={this.state?.isLoading || false}
                  stickyHeader={true}
                  editCallback={this.handleInlineEdits.bind(this)}
                  saveCallback={this.saveInlineEdits.bind(this)}
                  handleAddNewItem={this.handleAddNewItem.bind(this)}
                  addItemToList={true}
                  handleDelCallBack={this.handleDelCallBack}
                />
              </>
            )}
          </MDBRow>
        </MDBContainer>
        {this.state?.isMessageModalOpen && (
          <MessageModal
            open={this.state.isMessageModalOpen}
            showCustom={true}
            message={Message.deleteAdmin}
            title={"Confirm Deletion"}
            primaryButtonText={"Ok"}
            secondaryButtonText={"Cancel"}
            hideCancel={false}
            onConfirm={() => this.onModalConfirm()}
            handleClose={(e) => this.setState({ isMessageModalOpen: false })}
          />
        )}
      </div>
    );
  }
}

export default withUserContext(Unit);
